import React, { useState } from "react";
import { api } from "../api";

export default function UploadModal({ onClose, onUploaded }) {
  const [name, setName] = useState("");
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file || !name) return;
    setError("");
    setLoading(true);

    const formData = new FormData();
    formData.append("campaign_name", name);
    formData.append("file", file);

    try {
      await api.uploadCampaign(formData);
      onUploaded();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-backdrop">
      <div className="modal-content">
        <h3>Create New Campaign</h3>
        <p style={{ color: "var(--text-muted)", fontSize: "0.875rem", margin: "0.5rem 0 1.5rem" }}>
          Upload Excel (.xlsx) or CSV containing: <code>Mobile, Template Type, VAR1, VAR2, VAR3</code>
        </p>

        {error && <div style={{ color: "var(--danger)", marginBottom: "1rem", fontSize: "0.875rem" }}>{error}</div>}

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: "1rem" }}>
            <label className="card-label">Campaign Name</label>
            <input type="text" className="card" style={{ width: "100%", padding: "0.6rem" }} value={name} onChange={(e) => setName(e.target.value)} required />
          </div>

          <div style={{ marginBottom: "1.5rem" }}>
            <label className="card-label">File (.csv / .xlsx)</label>
            <input type="file" accept=".csv, .xlsx" className="card" style={{ width: "100%", padding: "0.6rem" }} onChange={(e) => setFile(e.target.files[0])} required />
          </div>

          <div style={{ display: "flex", justifyContent: "flex-end", gap: "0.5rem" }}>
            <button type="button" className="btn btn-outline" onClick={onClose} disabled={loading}>Cancel</button>
            <button type="submit" className="btn btn-primary" disabled={loading}>{loading ? "Processing File..." : "Upload & Validate"}</button>
          </div>
        </form>
      </div>
    </div>
  );
}